import React from 'react';
import type { ExplorerViewFilters } from '../../../server/utils/explorer-utils.ts';
import type { ExplorerState } from './use-explorer-query-params.ts';

export const ExplorerViewContext = React.createContext<{
    state: Partial<ExplorerState>;
    setState: React.Dispatch<React.SetStateAction<Partial<ExplorerState>>>;
    defaultFilters: Partial<ExplorerViewFilters>;
} | null>(null);
